import PropTypes from "prop-types";
import BannerImage from "@Assets/images/banner-image.png";

const AuthLayout = ({ children }) => {
  return (
    <div className="flex min-h-screen bg-white">
      {/* Left side background image */}
      <div
        className="w-7/12 bg-cover bg-right bg-gradient-to-b from-black to-black lg:block hidden m-[20px] xl:m-[30px] rounded-[30px]"
        style={{
          backgroundImage: `url(${BannerImage})`,
        }}
      ></div>

      {/* Right side content (form) */}
      <div className="flex-1 flex flex-col items-center justify-center p-0 md:p-8 bg-white my-6 md:my-0">
        {children}
      </div>
    </div>
  );
};

AuthLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AuthLayout;
